export const mergeData = (academicYears, cloneableMasterCourses, gradeLevels) => {
  academicYears.map(year => {
    year.courses = []
    cloneableMasterCourses.map(course => {
      if (course.academic_year_id === year.id) {
        gradeLevels.map(gl => {
          if (gl.id === course.grade_level_id) {
            year.courses.push({...course, grade_level_abbreviation: gl.abbreviation})
          }
        })
      }
    })
  })
  return academicYears
}

export const mergeJourneyData = (academicYears, cloneableJourneys, gradeLevels) => {
  console.log('gradeLevels in mergeJourneyData', gradeLevels)
  academicYears.map(year => {
    console.log('year', year)
    year.courses = []
    cloneableJourneys.map(journey => {
      console.log('journey', journey)
      if (journey.master_course.academic_year_id === year.id) {
        gradeLevels.map(gl => {
          console.log('gl', gl)
          if (gl.id === journey.master_course.grade_level_id) {
            year.courses.push({...journey, grade_level_abbreviation: gl.abbreviation})
          }
        })
      }
    })
  })
  console.log('academicYears in mergeJourneyData', academicYears)
  return academicYears
}



// WEBPACK FOOTER //
// ./src/utils/mycourses.js